<template>
    <div class="w-full rounded border border-gray-325 bg-white shadow">
        <div v-if="module.prompt" class="p-8 text-gray-700">
            <div v-html="module.prompt"></div>
        </div>

        <div class="">
            <slot></slot>
        </div>
        <div
            class="mt-8 w-full border-t border-gray-325 p-4"
            v-if="module.answer_rationale || module.video_answer_rationale"
        >
            <div
                v-if="!showModuleRationale"
                class="flex items-center justify-center p-4"
            >
                <span
                    @click="toggleShowModuleRationale"
                    class="hover:primary-600 text-center text-[16px] text-primary-525 underline hover:cursor-pointer"
                    >Show Answer</span
                >
            </div>

            <div
                v-if="showModuleRationale"
                class="flex flex-col gap-4 p-4 md:flex-row"
            >
                <div v-if="module.answer_rationale">
                    <span v-html="module.answer_rationale"></span>
                </div>

                <div
                    class="aspect-video h-auto md:h-48"
                    v-if="module.video_answer_rationale"
                >
                    <video-player
                        :video-token="module.video_answer_rationale"
                    ></video-player>
                </div>
            </div>
        </div>

        <!--  <div class="text-neutral-60 text-[14px] pt-4">-->
        <!--      {{ studentResponses[index] }}-->
        <!--  </div>-->
    </div>
</template>

<script>
import VideoPlayer from "@/Components/VideoPlayer";

export default {
    name: "StudentWorksheetModuleWrapper",
    components: {
        VideoPlayer,
    },
    props: {
        module: {
            type: Object,
            default: null,
        },
        moduleComplete: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModuleRationale: false,
        };
    },
    methods: {
        toggleShowModuleRationale() {
            this.showModuleRationale = !this.showModuleRationale;
        },
    },
};
</script>

<style scoped></style>
